<div class="asset-event-table">
    <p-table
        class="card-table card-table-asset-view"
        [value]="assetEvents"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>
                    Event Name
                    <p-sortIcon field="id"></p-sortIcon>
                </th>
                <th >
                    Dates <span style="font-size:10px;font-weight: lighter;">Start Date - End Date</span>
                </th>
                <th class="col-qty">
                    Qty. Loaned
                </th>
                <th class="col-qty">
                    Qty. Returned
                </th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry>
            <tr >
                <td>
                    {{entry?.event?.name}}
                </td>
                <td class="col-date">
                    {{entry?.event?.start_date | date: 'd MMM. y'}} - {{entry?.event?.end_date | date: 'd MMM. y'}}
                </td>
                <td class="col-multiline">
                    {{entry?.qty_on_loan}}
                </td>
                <td class="col-multiline">
                    {{entry?.qty_returned}}
                </td>

            </tr>
        </ng-template>
    </p-table>
</div>
